define('utils/cache',['jquery'], function ($) {
	
	/**
	 * Cache object
	 * Keeps cache with supporting functions
	 * 
	 * Global usage
	 * 
	 * cache.load(key, function () {
	 *  // on loaded callback
	 * });
	 * 
	 * make cache dirty, needs to be refreshed
	 * 
	 * cache.dirty(key);
	 * 
	 * options:
	 * 	bool: enable enable caching
	 * 	Source: source object to use
	 * 	function: onLoad: callback when loaded succesfully with key 
	 * 
	 */
	var Cache = function (defs) {
		this.options = $.extend({
			enable : true,
			source : null,
			
			onLoad : function () {}
        }, defs);
		
		this.cache = [];
		
		this.load = function (cache_id, callback_succes) {
			var $this = this;
			
			// in cache...!
			if(this.options.enable && this.cache[cache_id] != undefined) {
				callback_succes.call(this, this.cache[cache_id]);
			} else {		
				this.options.onLoad.call(this, cache_id);
				this.options.source.retrieve({ id: cache_id }, function (res) {
					$this.cache[cache_id] = res;
					callback_succes.call($this, res);
				});
			}
		};
		
		this.dirty = function (cache_id) {
			// TODO Kan natuurlijk veel mooier ;)
			this.remove(cache_id); 
		};
		
		this.exists = function (cache_id) {
			return this.cache[cache_id] != undefined;
		};
		
		this.remove = function (cache_id) {
			this.cache[cache_id] = undefined;
		};
		
		this.read = function (cache_id) {
			return this.cache[cache_id];
		};
	};

	// get item through a callback
	Cache.prototype.getItem = function (cache_id, callback_check) {
		var ret = null;
		var $this = this;
		
		this.load(cache_id, function (result) {
			$.each(result, function () {
				if(callback_check.call($this, this)) {
					ret = this;
				}
			});
		});
		
		return ret;
	};

	/**
	 * Helper functions to load a bunch of data
	 * @param source
	 * @param data
	 * @param callback_succes
	 */
	Cache.prototype.loadAll = function (source, data, callback_succes) {
		var id = source.options.index;
		var $this = this;
		source.retrieve(data, function (result) {
			$.each(result, function () {
				$this.cache[this[id]] = this;
			});
			
			if($.isFunction(callback_succes))
				callback_succes.call($this, result);
		});
	};
	
	return Cache;
	
});
